module.exports = {
  en: {
    'HRESS1EC2': {
      '10': 'For Year',
      '20': 'Appraisal No.',
      '30': 'Employee Code',
      '40': 'KPI Number',
      '50': 'Detail of KPI',
      '60': 'Target Value',
      '65': 'Weight',
      '70': 'Units',
      '80': 'Value',
      '90': 'Target Date',
      '100': 'Status',
      '110': 'Deteails of Work',
      '120': 'Item No.',
      '130': 'Details',
      '140': 'Actual Work Done',
      '150': 'Supervisor Support',
      '160': 'Achievement',
      '170': 'Date App.',
      '180': 'Achieved work',
      '190': 'Amount',
      '200': 'Acc.Amount',
      '210': 'Total amt.',
      '220': 'Detail of Supervisor Support'
    }
  },
  th: {
    'HRESS1EC2': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'รหัสพนักงาน',
      '40': 'ลำดับที่ KPI',
      '50': 'รายละเอียด KPI',
      '60': 'เป้าหมายที่กำหนด',
      '65': 'Weight',
      '70': 'หน่วย',
      '80': 'มูลค่า',
      '90': 'Target Date',
      '100': 'สถานะ',
      '110': 'รายละเอียดงานที่ต้องทำ',
      '120': 'Item No.',
      '130': 'Details',
      '140': 'Actual Work Done',
      '150': 'Supervisor Support',
      '160': 'Achieved Value',
      '170': 'วันที่บันทึก',
      '180': 'Achieved Value',
      '190': 'มูลค่า',
      '200': 'มูลค่าสะสม',
      '210': 'มูลค่ารวม',
      '220': 'รายละเอียดความช่วยเหลือของหัวหน้า'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hress1e.js